import axios from 'axios';
import { API_HOST, API_NAMESPACE, API_VERSION } from 'config/environment';

const triggerOtpUrl = `${API_HOST}/${API_NAMESPACE}/${API_VERSION}/users/trigger-otp?token=`;
const validateOtpUrl = `${API_HOST}/${API_NAMESPACE}/${API_VERSION}/users/validate-otp?token=`;

export const triggerOtp = (token) => {
  axios.post(`${triggerOtpUrl}${token}`);
};

export const validateOtp = async (token, otpInput) => {
  const response = await axios.post(`${validateOtpUrl}${token}`, {
    otp: otpInput,
  });

  return response.data;
};
